import { FC } from "react";

import { useRedirectToTextApp } from "hooks/use-redirect-to-text-app";

interface IProps {
  id: string;
  children: React.ReactNode;
}

export const RedirectTicketToTextApp: FC<IProps> = ({ id, children }) => {
  const { isFetching, isRedirecting } = useRedirectToTextApp(`/inbox/tickets/details/${id}`);

  if (isFetching || isRedirecting) {
    return null;
  }

  return children;
};
